<div class="textview">
  <span class="textview__label {{ labelCss }}">{{ label }}</span>
  <span class="textview__text {{ textCss }}">{{ displayedValue }}</span>
</div>
